/* eslint-disable */
import { useEffect, useRef } from 'react'
import scrollEventFn from '../scroll_event'
export default function Talent(){
  // scroll event
  const scroll01 = useRef(null)
  const scrollArr = [
    scroll01,
  ]
  useEffect(() => {
    window.scrollTo({top : 0, behavior : 'smooth'})
    // scroll event
    scrollEventFn(scrollArr)
    window.addEventListener("scroll", () => {scrollEventFn(scrollArr)})
    return () => {
      window.removeEventListener("scroll", () => {scrollEventFn(scrollArr)})
    }
  }, [])
  // html
  return(
    <div className="contents">
      <div className="content-title02">인재상</div>
      <div className="scrollBox" ref={scroll01}>
        <div className="content-text01">㈜DX손해사정법인은 창의적이고 도전적이며 자발적 협력을 추구하는 인재를 찾고 있습니다.</div>
        <img src="/img/recruit_01.png" className="talentImg top-100" alt=""/>
      </div>
    </div>
  )
}